export default "__VITE_ASSET__3af1a2b4__"